import { PropsWithChildren } from 'preact/compat';
import Icon from '../icon/Icon';
import { IconId } from '../icon/icons';
import './ChatClickableButton.less';

export type ChatClickableButtonProps = PropsWithChildren<{
    startIconId?: IconId;
    animationDelay?: number;
    onClick: () => void;
}>;

const ChatClickableButton = ({
    startIconId,
    animationDelay = 0,
    children,
    onClick
}: ChatClickableButtonProps) => (
    <button
        className={`bri-ChatClickableButton bri-DisplayFont bri-ZoomIn`}
        style={{ animationDelay: `${animationDelay}ms` }}
        onClick={onClick}
    >
        {startIconId && <Icon iconId={startIconId} size="small" />}
        <span>{children}</span>
    </button>
);

export default ChatClickableButton;
